import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeviceManagment from './DeviceManangment';
import NewDevice from './NewDevice';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import ModalConfirmDelete from '../../../Modals/ModalConfirmDelete';
import AlertBar from '../../../Modals/AlertBar';
import { checkStatus,getMonthTHFromInt } from '../../../../util/util';
import ModalConfirmUserInformation from '../../../Modals/ModalConfirmUserInformation';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';
import filter from 'lodash/filter';
import ImportExportDevice from './ImportExportDevice';
import { withNamespaces } from 'react-i18next';
import ExportReportDeviceInfo from '../ExportExcel/ExportReportDeviceInfo';


class DeviceInformation extends Component {
    constructor() {
        super();
        this.state  = {
            deviceList:[],
            deviceSelected:null,
            deviceSelectID:null,
            isShowEdit:false,
            isShowNew:false,
            currentPage:1,
            currentPageSize:10,
            totalPage:0,
            manageDevice: {},
            showModalConfirmManageDevice: false,
            showModalCancelManageDevice: false,
            ShowDeleteRow:false,
            notification:false,
            deviceSearch:'',
            isNewDevice: false,
            showModalConfirmNewDevice: false,
            dataNewDevice: {},
            openList : true,
            openAdd : false,
            openEdit: false,
            deviceGroupList: [],
            dataSort: 'device_id',
            isAsc: -1,
            reportDepartmentOfTransport: [],
            reportSummary: [],
            isGetExcel: false,
            reportName: ''
        };
    }

    componentDidMount(){
        const { objFromDeviceUserRelated } = this.props;
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
        this.getDeviceGroupList();
        if (objFromDeviceUserRelated.isFromDeviceUserRelated) {
            this.getDeviceListById(this.state.currentPage, this.state.currentPageSize);
        }
    }

    componentWillUnmount(){
        this.setState  = ({
            deviceList:[],
            deviceSelected:null,
            deviceSelectID:null,
            isShowEdit:false,
            isShowNew:false,
            currentPage:1,
            currentPageSize:10,
            totalPage:0,
            manageDevice: {},
            showModalConfirmManageDevice: false,
            showModalCancelManageDevice: false,
            ShowDeleteRow:false,
            notification:false,
            deviceSearch:'',
            isNewDevice: false,
            showModalConfirmNewDevice: false,
            isGetExcel: false
        });
    }

    getDeviceGroupList = () => {
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getDeviceGroupList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        name: obj.name || 'ไม่ระบุกลุ่ม',
                    });
                });
                this.setState({
                    deviceGroupList: objList
                });
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onPageSelect(page){
        const { currentPageSize, isAsc, dataSort } = this.state;
        const { user_id, user_name, token} = this.props;
        const dataCriteria = `${dataSort} : ${isAsc === '1' ? 1 : -1 }`;
        fetch(`http://203.150.199.244/api/admin/getDeviceList/${page}/${currentPageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "sort": eval('({' + dataCriteria + '})')
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceList:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,
                    currentPage:page,currentPageSize:currentPageSize})

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onPageSizeChange(page, pageSize){
        const { deviceSearch, dataSort, isAsc } = this.state;
        const { token } = this.props;
        let dataCriteria = {};
        dataCriteria = `${dataSort} : ${isAsc === '1' ? 1 : -1 }`;
        fetch(`http://203.150.199.244/api/admin/getDeviceList/${page}/${pageSize}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "filter":deviceSearch,
                "sort": eval('({' + dataCriteria + '})')
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceList:data.RESULT_DATA,
                    totalPage:data.RESULT_TOTAL,
                    currentPage:page,currentPageSize:pageSize})
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getDeviceListById(page, pageSize) {
        const { dataSort, isAsc } = this.state;
        const { token, objFromDeviceUserRelated} = this.props;
        let dataCriteria = {};
        dataCriteria = `${dataSort} : ${isAsc === '1' ? 1 : -1 }`;
        fetch(`http://203.150.199.244/api/admin/getDeviceList/${page}/9999`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "sort": eval('({' + dataCriteria + '})')
            })
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceList: data.RESULT_DATA,
                    totalPage: data.RESULT_TOTAL,
                    currentPage: page,currentPageSize:pageSize
                })
            })
            .then(() => {
                if (objFromDeviceUserRelated.isFromDeviceUserRelated) {
                    this.onOpenEditFromDeviceUserRelated(objFromDeviceUserRelated.deviceId);
                }
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    newDevice(){
        this.setState({
            isNewDevice: true,
            isShowNew: false
        });
    }

    onCloseNewDevice = () => {
        this.setState({
            isNewDevice: false,
            isShowNew: false
        });
    }

    onSubmitNewDevice = (dataNewDevice) => {
        this.setState({ dataNewDevice });
        AlertConfirm("เพิ่ม Device","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
            if(isOk){
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;

                const { dataNewDevice } = this.state;

                fetch(`http://203.150.199.244/api/admin/newDevice`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "box_id": dataNewDevice.box_id,
                        "device_no": dataNewDevice.device_no,
                        "imei": dataNewDevice.imei,
                        "sim_no": dataNewDevice.simNo,
                        "model": dataNewDevice.model,
                        "network_operator": dataNewDevice.network_operator,
                        "external_device": dataNewDevice.external_device
                    })
                })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({
                            showModalConfirmNewDevice: false,
                            openList : true,
                            openAdd : false,
                            openEdit : false,
                        })
                    })
                    .then(() => {
                        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize)
                    })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
        });
    }

    onClickCancelNewDevice = () => {
        this.setState({
            showModalConfirmNewDevice: false
        });
    }

    onClickConfirmNewDevice = () => {
        const {
            user_name,
            user_id,
            token
        } = this.props;

        const { dataNewDevice } = this.state;

        fetch(`http://203.150.199.244/api/admin/newDevice`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "serial": dataNewDevice.serial,
                "imei": dataNewDevice.imei,
                "sim_no": dataNewDevice.simNo,
                "model": dataNewDevice.model,
                "vendor": dataNewDevice.vendor
            })
        })
            .then(response => { return checkStatus(response)})
            .then(this.onPageSizeChange(1, 10))
            .then(() => {
                this.setState({
                    showModalConfirmNewDevice: false,
                    isNewDevice: false,
                    notification: true
                })
            })
            .then(setTimeout(() => {
                this.setState({notification: false});
            }, 3000))
            .then(() => {
                this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize)
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onNewDeviceClose(){
        this.btnNewClose.click();
        this.setState({
            isShowNew:false
        })
    }

    editeDevice(device, key){
        this.setState({
            deviceSelectID:device.device_id,
            isShowEdit:true,
            deviceSelected:device,
        })
    }

    onEditDeviceClose(){
        this.btnEditClose.click();
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
        this.setState({
            isShowEdit:false
        })
    }

    deleteDevice(device){
        this.setState({
            deviceSelectID:device.device_id,
            // ShowDeleteRow: true,
        })

        AlertConfirm("ลบ Device","คุณต้องการลบ Device หรือไม่").then(isOk=>{
            if(isOk){
                const { token } = this.props;
                const { deviceSelectID } = this.state;

                fetch(`http://203.150.199.244/api/admin/deleteDevice/${deviceSelectID}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "token":token,
                    },
                    body: JSON.stringify({
                        // "device_status":"Inactive"
                    })
                })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({
                            ShowDeleteRow: false,
                            // notification: true
                         })
                    })
                    .then(() => {

                            // if (sideBarName === 'deviceInformation') {
                            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize)
                            // }
                        }
                    )
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
        }
    });
    }

    onClickCancelDelete = (status) => {
        this.setState({ ShowDeleteRow: status });
    }

    convertDateFormat(date){
        let dateString = date.substring(0,10);
        let str = dateString.split("-");
        let year = parseInt(str[2])+543;
        let month = getMonthTHFromInt(parseInt(str[1]));
        return str[0]+' '+month.toString()+' '+year.toString();
    }

    convertUpdateDateFormat(date){
        let str = date.split(" ");
        let year = parseInt(str[2])+543;
        return str[0]+' '+str[1]+' '+year.toString()+' '+str[4];
    }

    onClickConfirmDelete = () => {
        const { token } = this.props;

        const { deviceSelectID } = this.state;

        fetch(`http://203.150.199.244/api/admin/deleteDevice/${deviceSelectID}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token":token,
            },
            body: JSON.stringify({
                "device_status":"Inactive"
            })
        })
            .then(response => { return checkStatus(response)})
            .then((response) => {
                this.setState({ ShowDeleteRow: false, notification: true })
            })
            .then(setTimeout(() => {
                this.setState({ notification: false });
            }, 3000))
            .then(() => {

                    // if (sideBarName === 'deviceInformation') {
                        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize)
                    // }
                }
            )
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onPasswordKeyPress(e){
        if (e.key === 'Enter') {
            this.onClickSearch();
        }
    }

    handleChange = (event) => {
        var val = event.target.value;

        this.setState({
            deviceSearch: val
        });

        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    onClickSearch = () => {

        let name = this.state.deviceSearch;

        this.setState({deviceSearch:name});
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    onClickBack = () =>{
        this.setState({
            openList : true,
            openAdd : false,
            openEdit : false,
        });
        this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    onOpenAdd = () => {
        // this.setState({dataNewDriver: data}, () => this.onClickConfirmUserInformation());
        this.setState({
            openList : false,
            openAdd : true,
        });
    }

    onOpenEdit = (device) => {
        // console.log('device:', device);
        // console.log('device:', device.device_id);
        this.setState({
            openList : false,
            openEdit : true,
            deviceSelectID: device.device_id,
            isShowEdit: true,
            deviceSelected: device,
        });
    }

    onOpenEditFromDeviceUserRelated = (deviceId) => {
        const device = filter(this.state.deviceList, o => o.device_id === deviceId)
        this.setState({
            openList: false,
            openEdit: true,
            deviceSelectID: deviceId,
            isShowEdit: true,
            deviceSelected: device[0]
        });
    }

    getReportDepartmentOfTransport() {
        const { t, token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getDeviceDLTList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        car_no: obj.car_no,
                        car_province: obj.car_province,
                        car_type_id: obj.car_type_id,
                        change_detail: obj.change_detail,
                        chassis: obj.chassis,
                        device_id: obj.device_id,
                        imei: obj.imei,
                        inform_date: obj.inform_date,
                        install_date: obj.install_date,
                        model: obj.model,
                        tracking_dtm: obj.tracking_dtm,
                        type: obj.type
                    });
                });
                this.setState({
                    reportDepartmentOfTransport: objList,
                    reportName: 'transport',
                    isGetExcel: true
                });
            })
            .then(() => {
                this.setState({
                    isGetExcel: false
                });
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    getReportSummary() {
        const { t, token } = this.props;
        console.log('getReportSummary::::');
        fetch(`http://203.150.199.244/api/admin/getDeviceUserDetaiList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        alert_engine_off: obj.alert_engine_off,
                        alert_engine_on: obj.alert_engine_on,
                        company: obj.company,
                        device_group: obj.device_group,
                        device_id: obj.device_id,
                        device_no: obj.device_no,
                        expire_date: obj.expire_date,
                        install_date: obj.install_date,
                        name: obj.name,
                        speed_limit: obj.speed_limit,
                        user_name: obj.user_name
                    });
                });
                this.setState({
                    reportSummary: objList,
                    reportName: 'summary',
                    isGetExcel: true
                });
            })
            .then(() => {
                this.setState({
                    isGetExcel: false
                });
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    render() {
        const {
            deviceSelectID,
            deviceList,
            currentPageSize,
            deviceSelected,
            totalPage,
            ShowDeleteRow,
            notification,
            showModalConfirmNewDevice,
            openList,
            openAdd,
            openEdit,
            deviceGroupList,
            reportDepartmentOfTransport,
            isGetExcel,
            reportSummary,
            reportName
        } = this.state;

        const {
            t,
            user_id,
            user_name,
            token,
            userLevel,
            history
        } = this.props;
        let rows = [];
        let user_ids = this.hasOwnProperty(history.location.state) ? history.location.state.deviceId : this.hasOwnProperty(deviceSelected) ? deviceSelected.device_id : null;
        deviceList.map((device,key)=>{
            rows.push(
                <tr key={key}>
                <td >{device.device_id}</td>
                <td >{device.device_group}</td>
                {userLevel === 3 || userLevel === 4 ?
                    <td>{device.device_driver}</td> : null
                }
                <td>{device.device_no}</td>
                <td>{device.model.toUpperCase()}</td>
                <td>{device.imei}</td>
                {userLevel === 0 || userLevel === 1 ?
                    <td>{device.sim_no}</td> : null
                }
                {userLevel === 0 || userLevel === 1 ?
                    <td>{device.network_operator}</td> : null
                }
                <td>{device.install_date ? this.convertDateFormat(device.install_date) : device.install_date}</td>
                <td>{device.expire_date ? this.convertDateFormat(device.expire_date) : device.expire_date}</td>
                {/* <td>{device.last_upd_dtm ? this.convertUpdateDateFormat(device.last_upd_dtm) : device.last_upd_dtm}</td> */}
                <td>{(device.tracking_dtm) ? device.tracking_dtm : ''}</td>
                <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
                    <button onClick={this.onOpenEdit.bind(this, device, key)} className="btn btn-primary btn-xs" data-title="Edit" data-toggle="modal"
                    data-target="#editDevice"  data-backdrop="static" data-keyboard="false"><span className="fa fa-pencil" /></button></p></td>
                {
                    userLevel !== 2 && userLevel !== 3 && userLevel !== 4 &&

                    <td><p data-placement="top" data-toggle="tooltip" title="Delete">
                    <button onClick={this.deleteDevice.bind(this,device)} className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal"
                    data-target="#deleteDevice" data-backdrop="static" data-keyboard="false"><span className="fa fa-trash" /></button></p></td>
                }

                </tr>
            )

        });

        return(

        <div className="gray-panel">
                { notification &&
                    <AlertBar />
                }

                        <div className="col-md-12">
                        <h1 className="page-header"> <i className="fa fa-sliders" style={{color: '#7386D5'}} />&nbsp;{t('ตั้งค่าตัวเครื่อง')}</h1>
                    </div>
                    <br />

                    {
                            openList &&
                            <div>
                    <nav>
                        <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                             <a className="nav-item nav-link active" id="nav-list-tab" data-toggle="tab" href="#nav-list" role="tab" aria-controls="nav-list" aria-selected="true">{t('รายการ')}</a>
                            <a className="nav-item nav-link" id="nav-import-tab" data-toggle="tab" href="#nav-import" role="tab" aria-controls="nav-import" aria-selected="false">{t('นำเข้า/ส่งออก')}</a>
                        </div>
                    </nav>
                    <div className="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">

                                <div className="form-inline form-group">
                                    <label htmlFor="focusedInput" className="col-md-1">{t('ค้นหา')}</label>
                                    <div  className="col-md-4" >
                                        <input className="form-control col-7 col-md-5" style={{marginRight:5}}  id="focusedInput" type="text" onChange={this.handleChange} onKeyUp={this.handleChange} onKeyPress={this.onPasswordKeyPress.bind(this)} />
                                        <input type="button" className="btn btn-info" value="ค้นหา" onClick={this.onClickSearch} />
                                    </div>

                                    <label htmlFor="focusedInput" className="col-md-1" >{t('เรียงตาม')}</label>
                                    <div>
                                        <select
                                            name="sorts"
                                            className="form-control"
                                            onChange={(e) => this.setState({ isAsc: e.target.value })}>
                                            <option value="-1">{t('มากไปน้อย')}</option>
                                            <option value="1">{t('น้อยไปมาก')}</option>
                                        </select>
                                        <select
                                            name="dataSort"
                                            className="form-control"
                                            onChange={(e) => this.setState({ dataSort: e.target.value })}>
                                            <option value="device_id">{t('จัดกลุ่ม')}</option>
                                            <option value="device_no">{t('ทะเบียนรถ')}</option>
                                            <option value="imei">{t('อีมี่')}</option>
                                            <option value="model">{t('รุ่น')}</option>
                                            <option value="network_operator">{t('โครงข่าย')}</option>
                                            <option value="device_id">{'ID'}</option>
                                        </select>

                                        <input type="button" className="btn btn-info" value={t('เรียง')} onClick={this.onClickSearch} />
                                    </div>
                                    <div style={{ paddingLeft: '40px' }}>
                                        <a
                                            className="btn btn-info pull-right push-right-sm"
                                            onClick={() => this.getReportDepartmentOfTransport()}>
                                            <i className="fa fa-fw fa-print" ></i> กรมขนส่ง
                                        </a>
                                    </div>
                                    <div style={{ paddingLeft: '10px' }}>
                                        <a className="btn btn-warning pull-right push-right-sm"
                                           onClick={() => this.getReportSummary()} >
                                            <i className="fa fa-fw fa-file-excel-o"></i> สรุปรายการ
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-12 table-responsive">
                                    <table  className="table table-bordred table-striped table-hover ">
                                        <thead >
                                        <tr>
                                        <th>ID</th>
                                        <th style={{minWidth:100}}>{t('จัดกลุ่ม')}</th>
                                        {userLevel === 3 || userLevel === 4 ?
                                            <th style={{minWidth: 200}}>ชื่อ / พนักงานขับรถ</th> : null
                                        }
                                        <th style={{minWidth:100}}>{t('ทะเบียนรถ')}</th>
                                        <th style={{minWidth:80}}>{t('รุ่น')}</th>
                                        <th style={{minWidth:100}}>IMEI</th>
                                        {userLevel === 0 || userLevel === 1 ?
                                             <th style={{minWidth:100}}>simNo</th> : null
                                        }
                                        {userLevel === 0 || userLevel === 1 ?
                                            <th style={{minWidth:100}}>Operator</th> : null
                                        }
                                        <th style={{minWidth:90}}>{t('วันที่ติดตั้ง')}</th>
                                        <th style={{minWidth:90}}>{t('ครบกำหนด')}</th>
                                        <th style={{minWidth:140}}>{t('อัพเดทล่าสุด')}</th>
                                        <th style={{textAlign:'right'}}>
                                            <button
                                                onClick={this.onOpenAdd.bind(this)}
                                                style={{ visibility: (userLevel === 0 || userLevel === 1) ? '' : 'hidden' }}
                                                className="btn btn-info btn-xs"
                                                data-title="Add" data-toggle="modal" >
                                                <span className="fa fa-plus" />
                                            </button>
                                        </th>
                                        <th></th>
                                        </tr></thead>
                                    <tbody>
                                        {rows}
                                    </tbody>
                                    </table>
                                </div>

                            {/* Report for Department of transport */}
                            <div>
                                <table id='table-to-excel-transport' border='1' style={{fontSize: '14px', backgroundColor: 'white', visibility: 'collapse'}} >
                                    <thead>
                                        <tr>
                                            <th rowSpan={2} width="56" className="text-center">ลำดับที่</th>
                                            <th rowSpan={2} width="56" className="text-center">เลขที่</th>
                                            <th rowSpan={2} width="100" className="text-center">หมายเลขทะเบียนรถ</th>
                                            <th rowSpan={2} width="80" className="text-center">จังหวัด</th>
                                            <th rowSpan={2} width="100" className="text-center">หมายเลขคสซี</th>
                                            <th rowSpan={2} width="100" className="text-center">รหัสประเภทรถ</th>
                                            <th colSpan={4} width="900" className="text-center">เครื่อง GPS</th>
                                            <th rowSpan={2} width="80" className="text-center">รหัสอ้างอิง (ถ้ามี)</th>
                                            <th rowSpan={2} width="200" className="text-center">เวลาอัพเดทล่าสุด</th>
                                            <th rowSpan={2} width="150" className="text-center">รายละเอียดการแก้ไขเปลี่ยนแปลง</th>
                                            <th rowSpan={2} width="80" className="text-center">วันที่แจ้ง</th>
                                        </tr>
                                    <tr>
                                        <th width="150" className="text-center">ชนิด</th>
                                        <th width="150" className="text-center">แบบ</th>
                                        <th width="150" className="text-center">หมายเลขเครื่อง</th>
                                        <th width="200" className="text-center">วันที่ติดตั้ง</th>
                                    </tr>
                                    </thead>
                                    <tbody style={{textAlign: 'center'}}>
                                    {
                                        reportDepartmentOfTransport.map((data, key) => {
                                            return (
                                                <tr className="namTrhover" key={key}>
                                                        <td width="56">{key + 1}</td>
                                                        <td width="56">{data.device_id}</td>
                                                        <td width="100">{data.car_no}</td>
                                                        <td width="80">{data.car_province}</td>
                                                        <td width="100">{data.chassis}</td>
                                                        <td width="100">{data.car_type_id}</td>
                                                        <td >{data.type}</td>
                                                        <td >{data.model}</td>
                                                        <td >{data.imei}</td>
                                                        <td >{data.install_date}</td>
                                                        <td width="80">{''}</td>
                                                        <td width="80">{data.tracking_dtm}</td>
                                                        <td width="80">{data.change_detail}</td>
                                                        <td width="80">{data.inform_date}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>


                            {/* Report summary of list*/}
                            <div>
                                <table id='table-to-excel-summary' border='1' style={{fontSize: '14px', backgroundColor: 'white', visibility: 'collapse'}} >
                                    <thead>
                                    <tr>
                                        <th rowSpan={2} width="56" className="text-center">ลำดับที่</th>
                                        <th rowSpan={2} width="56" className="text-center">Number</th>
                                        <th rowSpan={2} width="100" className="text-center">กลุ่มรถ</th>
                                        <th rowSpan={2} width="80" className="text-center">ทะเบียน</th>
                                        <th rowSpan={2} width="100" className="text-center">Username</th>
                                        <th rowSpan={2} width="100" className="text-center">Name</th>
                                        <th rowSpan={2} width="100" className="text-center">Company</th>
                                        <th rowSpan={2} width="80" className="text-center">Setup Date</th>
                                        <th rowSpan={2} width="200" className="text-center">Expire Date</th>
                                        <th rowSpan={2} width="150" className="text-center">จำกัดความเร็ว</th>
                                        <th colSpan={2} width="400" className="text-center">การแจ้งเตือน</th>
                                    </tr>
                                    <tr>
                                        <th width="150" className="text-center">เครื่องยนต์ ดับเครื่อง</th>
                                        <th width="150" className="text-center">เครื่องยนต์ ติดเครื่อง</th>
                                    </tr>
                                    </thead>
                                    <tbody style={{textAlign: 'center'}}>
                                    {
                                        reportSummary.map((data, key) => {
                                            return (
                                                <tr className="namTrhover" key={key}>
                                                    <td width="56">{key + 1}</td>
                                                    <td width="56">{data.device_id}</td>
                                                    <td>{data.device_group}</td>
                                                    <td>{data.device_no}</td>
                                                    <td>{data.user_name}</td>
                                                    <td>{data.name}</td>
                                                    <td>{data.company}</td>
                                                    <td>{data.install_date}</td>
                                                    <td>{data.expire_date}</td>
                                                    <td>{data.speed_limit}</td>
                                                    <td>{data.alert_engine_on}</td>
                                                    <td>{data.alert_engine_off}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>

                                <RCPagination
                                    onSelect={this.onPageSelect.bind(this)}
                                    onShowSizeChange={this.onPageSizeChange.bind(this)}
                                    total={totalPage}
                                    pageSize={currentPageSize}
                                />
                        </div>
                        <div className="tab-pane fade" id="nav-import" role="tabpanel" aria-labelledby="nav-import-tab">
                            <ImportExportDevice
                                t={t}
                                user_id={user_id}
                                user_name={user_name}
                                token={token}
                                deviceGroupList={deviceGroupList}
                            />
                        </div>
                    </div>


                    </div>
                    }
                    {
                    openAdd &&
                    <NewDevice
                        user_id={user_id}
                        user_name={user_name}
                        token={token}
                        onCloseNewDevice={this.onCloseNewDevice}
                        onSubmitNewDevice={this.onSubmitNewDevice}
                        onBack={this.onClickBack}
                    />
                    }

                    {
                        openEdit &&
                        <DeviceManagment
                            user_id={user_id}
                            user_name={user_name}
                            token={token}
                            deviceSelected={deviceSelected}
                            deviceId = {user_ids}
                            // deviceId = {deviceSelected.device_id}
                            deviceID={deviceSelectID}
                            onClose={this.onEditDeviceClose.bind(this)}
                            userLevel={userLevel}
                            onBack={this.onClickBack}
                            history={history}
                        />

                    }
                         { ShowDeleteRow &&
                            <ModalConfirmDelete
                                onClickCancelDelete={this.onClickCancelDelete}
                                onClickConfirmDelete={this.onClickConfirmDelete}
                            />
                         }

                        { showModalConfirmNewDevice &&
                        <ModalConfirmUserInformation
                            onClickCancelUserInformation={this.onClickCancelNewDevice}
                            onClickConfirmUserInformation={this.onClickConfirmNewDevice}
                        />
                        }
                        {
                            isGetExcel &&
                            <ExportReportDeviceInfo
                                table={`table-to-excel-${reportName}`}
                                filename="excelFile"
                                sheet="sheet 1"
                                buttonText=""
                            />
                        }
                    <input type="hidden" ref="txtDeviceID" />
                </div>

        );
    }
}

DeviceInformation.defaultProps = {
    objFromDeviceUserRelated: {}
}

DeviceInformation.propTypes = {
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    sideBarName: PropTypes.string.isRequired,
    objFromDeviceUserRelated: PropTypes.object,
    history: PropTypes.object
}

export default withNamespaces('Menubar')(DeviceInformation);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/DeviceInformation.js